import { IS_STAGING } from '@constants';

/**
 * Using dev envorinment for installing apps
 */
export const getInstallingAppImage = (
  image: string,
  devImage = 'ghcr.io/neuro-inc/app-deployment:development',
) => (IS_STAGING ? image : devImage);
